var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12V12C20.5 10.1644 20.5 8.67321 18.3929 7.02225C18.328 6.97143 18.233 7.02021 18.2316 7.1026C18.1558 11.4602 15.6402 12.3231 15.4 11.4333C13.5159 4.45359 11.0119 4.08259 9.31196 3.547C9.24318 3.52533 9.17424 3.58341 9.18053 3.65525C9.71339 9.74082 8.59473 10.8672 7.47299 11.4302C7.46876 11.4323 7.46421 11.4342 7.45972 11.4356C5.0298 12.2422 4.23081 10.6936 3.68385 9.54785C3.63839 9.45262 3.50001 9.48466 3.5 9.59018L3.50001 12.5667C3.49999 17.1 7.30557 20.5 12 20.5Z",
    stroke: "url(#paint0_linear_1673_22527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1673_22527",
    x1: 14.6283,
    y1: 2.4375,
    x2: 25.3349,
    y2: 15.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFCE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531251,
    stopColor: "#FEF0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA86F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.81fdaf1b32aff291d23941a3f3c0db0b.svg";
export { ForwardRef as ReactComponent };